import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormArray, FormGroup} from '@angular/forms';

@Component({
  selector: 'kv-promo-layout-detail-fields',
  template: `
    <form [formGroup]="form">
      <div style="margin-top: 50px"
           formArrayName="details"
           *ngFor="let item of controls(); let i=index">
        <div [formGroupName]="i">
          <button
            pButton
            type="button"
            class="k-generic-btn"
            icon="fa fa-minus-circle"
            iconPos="left"
            label="{{ 'common.delete' | translate }}"
            (click)="deleteDetailList(i)">
          </button>
          <div class="ui-g ui-fluid master-data customer-cards-info">
            <p-panel class="ui-g-12 ui-md-12">
              <p-header>
                <div class="ui-helper-clearfix" style="margin-top: 1px">
                  <span class="ui-panel-title"><h3 style="text-align: center">{{ 'promotion.currentRowNumber' | translate }}: {{rowNumbers[i]}}</h3></span>
                </div>
              </p-header>
              <div class="ui-g-12 ui-fluid">
                <div class="ui-g-12">
                  <div>
                    <div [kv-form-element]="{ label: 'promotion.rowNumber', md: '2' }">
                      <input type="number" min="0" pInputText formControlName="row_num" />
                    </div>
                  </div>
                    <div [kv-form-element]="{ label: 'promotion.description', md: '10' }">
                      <input
                        type="text"
                        pInputText
                        formControlName="description" />
                    </div>
                    <div [kv-form-element]="{ label: 'promotion.rowStyle', md: '6' }">
                      <input
                        type="text"
                        pInputText
                        formControlName="row_style" />
                    </div>
                    <div [kv-form-element]="{ label: 'promotion.rowPosition', md: '4' }">
                      <p-dropdown
                        [options]="layoutDetailRowPositions"
                        formControlName="row_position_pid">
                      </p-dropdown>
                    </div>
                    <div>
                      <div [kv-form-element]="{ label: 'promotion.rowValue', md: '2' }">
                        <input type="number" min="0" pInputText formControlName="row_value" />
                      </div>
                    </div>
                    <div [kv-form-element]="{ label: 'promotion.bmpPath', md: '4' }">
                      <input
                        type="text"
                        pInputText
                        formControlName="bmp_path" />
                    </div>
                    <div [kv-form-element]="{ label: 'promotion.bmpRef', md: '4' }">
                      <input
                        type="text"
                        pInputText
                        formControlName="bmp_ref" />
                    </div>
                    <div [kv-form-element]="{ label: '', md: '1' }"></div>
                    <div [kv-form-element]="{ label: 'promotion.graph', md: '2' }">
                      <p-inputSwitch formControlName="flg_graph"></p-inputSwitch>
                    </div>
                    <div [kv-form-element]="{ label: '', md: '1' }"></div>
                </div>
              </div>
            </p-panel>
          </div>
        </div>
      </div>
    </form>
  `
})
export class LayoutDetailFieldsComponent implements  OnInit{

  @Input() layoutDetailRowPositions;
  @Input() form: FormGroup;
  @Input() details: FormArray;
  @Output() deleteElement = new EventEmitter();

  rowNumbers: number[] = [];

  controls() {
    return  (<any>this.form.get('details')).controls;
  }
  constructor() {}

  ngOnInit(): void {
    if (this.form.controls['details'].value.length > 0) {
      this.rowNumbers = [];
      for (let i = 0; i < this.form.controls['details'].value.length; i++) {
        this.rowNumbers[i] = this.form.controls['details'].value[i].row_num;
      }
    }
  }

  deleteDetailList(index) {
    this.deleteElement.emit(index);
    this.rowNumbers.splice(index, 1);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/promotion/layout/components/layoutDetailFields.component.ts